import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ApContentService } from '@ap/content';

import { MijnLoginNavigation } from '../mijn-login.navigation';
import { MijnLoginService } from '../mijn-login.service';

import content from './browsercode-herstel.wrapper.content.json';
import { BrowsercodeHerstelWrapperService } from './browsercode-herstel.wrapper.service';

/**
 * @ngdoc component
 * @name BrowsercodeHerstelWrapperComponent
 * @module BrowsercodeHerstelWrapperModule
 */
@Component({
    selector: 'browsercode-herstel',
    templateUrl: './browsercode-herstel.wrapper.component.html',
    standalone: false
})
export class BrowsercodeHerstelWrapperComponent implements OnInit, OnDestroy {
    public changeBrowserCodeDisabled = false;
    public readonly subscription: Subscription = new Subscription();

    public constructor(
        private readonly contentService: ApContentService,
        private readonly browsercodeHerstelWrapperService: BrowsercodeHerstelWrapperService,
        private readonly mijnLoginNavigation: MijnLoginNavigation,
        private readonly mijnLoginService: MijnLoginService
    ) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        if (this.mijnLoginService.getKeyChainId() === undefined) {
            this.mijnLoginNavigation.toLogin();
            return;
        }
    }

    public cancel(): void {
        this.mijnLoginNavigation.toLogin();
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    public changeBrowserCode(): void {
        this.changeBrowserCodeDisabled = true;
        this.subscription.add(
            this.browsercodeHerstelWrapperService.removeBrowserRegistration().subscribe({
                next: () => {
                    this.mijnLoginService.setKeyChainId(null);
                },
                complete: () => {
                    this.mijnLoginNavigation.external(this.contentService.get('mijn.login.browsercode.herstel.wrapper.link'));
                }
            })
        );
    }
}
